var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/hoc/withImageFallback.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var withImageFallback = function withImageFallback(Component, Fallback) {
  return function (_React$Component) {
    (0, _inherits2.default)(_class, _React$Component);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      (0, _classCallCheck2.default)(this, _class);
      _this = _super.call(this, props);
      _this.state = {
        error: false
      };
      return _this;
    }

    (0, _createClass2.default)(_class, [{
      key: "onError",
      value: function onError(error) {
        this.setState({
          error: true
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var error = this.state.error;

        if (error || !this.props.src) {
          return _react.default.createElement(Fallback, (0, _extends2.default)({
            fontSize: this.props.size
          }, this.props, {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 20,
              columnNumber: 24
            }
          }));
        }

        return _react.default.createElement(Component, (0, _extends2.default)({
          onError: function onError(e) {
            return _this2.onError(e);
          }
        }, this.props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 22,
            columnNumber: 20
          }
        }));
      }
    }]);
    return _class;
  }(_react.default.Component);
};

var _default = withImageFallback;
exports.default = _default;